import { useTranslation } from 'react-i18next';
import { useStore } from '../../store/database';
import type { SupportedLang } from '../../config/house.config';

export default function MessagesPage() {
  const { t, i18n } = useTranslation();
  const messages = useStore(s => s.house_messages.filter(m => m.is_published && !m.deleted_at));
  const lang = i18n.language as SupportedLang;

  return (
    <div className="space-y-6">
      <h1 className="font-serif text-2xl tracking-widest">{t('messages.title')}</h1>
      {messages.length === 0 && <p className="text-sm text-charcoal/50 font-sans">{t('messages.noMessages')}</p>}
      <div className="space-y-6">
        {messages.sort((a, b) => (b.published_at || '').localeCompare(a.published_at || '')).map(m => {
          const tr = m.translations[lang] || m.translations.en;
          return (
            <article key={m.id} className="border-b border-charcoal/5 pb-6">
              <h2 className="font-serif text-xl">{tr.title}</h2>
              <p className="text-[10px] text-charcoal/30 font-sans mt-1">{m.published_at ? new Date(m.published_at).toLocaleDateString() : ''}</p>
              <p className="text-sm font-sans text-charcoal/70 mt-3 leading-relaxed whitespace-pre-line">{tr.content}</p>
            </article>
          );
        })}
      </div>
    </div>
  );
}
